import * as React from 'react';
import moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Button from '../../components/forms/button'
import { isMobile } from 'react-device-detect';

const IAC0101_Table = (props) => {
    if (props === null) { return ""; }
    let datalist = props.data && props.data.map(item => ({
                ...item
            }));

    if (datalist === null || datalist === undefined || datalist.length === 0) {
        datalist = [];
    }

    var pageNo = JSON.parse(JSON.stringify(props.pageNo));
    const sizePerPageList = [
        { text: '10件', value: 10 },
        { text: '25件', value: 25 },
        { text: '50件', value: 50 },
        { text: '100件', value: 100 },
    ];
    var selectedSize = sizePerPageList.filter(option => option.value == props.sizePerPage)[0];
    if (selectedSize === null || selectedSize === undefined) {
        selectedSize = sizePerPageList[0];
    }
    var sizePerPage = selectedSize.value;

    const options = {
        paginationShowsTotal: renderShowTotal,
        sizePerPageList: sizePerPageList,  // you can change the dropdown list for size per page
        page: pageNo,  // which page you want to show as default
        paginationPosition: "bottom",
        sizePerPage: sizePerPage,  // which size per page you want to locate as default
        paginationSize: 4,  // the pagination bar size.
        hideSizePerPage: true,
        noDataText: props.getTranslateValue(props.translate.current, "messages.common.norecord")
    };
    var pagination = true;

    String.prototype.format = function () {
        var content = this;
        for (var i = 0; i < arguments.length; i++) {
            var replacement = '{' + i + '}';
            content = content.replace(replacement, arguments[i]);
        }
        return content;
    };

    function renderShowTotal(start, to, total) {
        let totalText = props.getTranslateValue(props.translate.current, "views.shared.showtotal");
        let tokens = totalText.split('[');
        let firstHalf = tokens[0].format(total);
        firstHalf = `${start}-${to}${firstHalf}`
        let secondHalf = tokens[1].split(']')[1].format(total, null, null);
        let displayPagination = datalist.length === 0 ? "d-none" : "d-block";
        return (
            <div className={displayPagination} style={datalist.length === 0 ? { marginBottom: "4px" } : { marginBottom: "0px" }}>
                <span>{firstHalf}</span>
                {!isMobile && (
                    <div>
                        <RenderSizeDropdown />
                        <span>{secondHalf}</span>
                    </div>
                )}
            </div>
        )
    }

    function RenderSizeDropdown() {
        return (
            <span className="dropdown react-bs-table-sizePerPage-dropdown">
                <select value={selectedSize.value} className="multiselect dropdown-toggle input-group-text" style={{ display: "inline-grid" }} onChange={e => props.setSizePerPage(e.target.value)}>
                    {
                        sizePerPageList.map(function (option, index) {
                            return <option key={index} value={option.value}>{option.text}</option>
                        })
                    }
                </select>
            </span>
        )
    }

    function renderSelectButton(cell, row) {
        return (
            <div className="action-cell">
                <Button style={{ paddingTop: "3px", paddingBottom: "3px", width: "100%" }} color="success" className="flex-grow-0" label={props.getTranslateValue(props.translate.current, "views.iac0101.select")} onClick={() => props.onSelectFacility && props.onSelectFacility(row)} />
            </div>
        )
    }

    function renderFacilityNameAndAddressMobile (cell, row){
        return (
            <div style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                    {row.FacilityName}
                </div>
                <div>
                    {row.Address}
                </div>
                <Button style={{ paddingTop: "3px", paddingBottom: "3px", width: "80%" }} color="success" className="flex-grow-0" label={props.getTranslateValue(props.translate.current, "views.iac0101.select")} onClick={() => props.onSelectFacility && props.onSelectFacility(row)} />
            </div>
            
        )
    }

    function trClassFormat(rowData, rIndex) {
        return `table-new-tr-${rIndex}`;
    }

    
    return (
        <div>
            {props.hasSearched && props.resultCount > 0 && (
                <div style={{ margin: '0px 0 8px 0', fontWeight: 'bold' }}>
                    {(props.resultCount || 0).toLocaleString()} {props.getTranslateValue(props.translate.current, "views.iac0101.foundmatchingdata")}
                </div>
            )}
            <BootstrapTable hover data={datalist} options={options} pagination={props.isTablet == true ? false : pagination} tableHeaderClass="table-header-style" trClassName={trClassFormat} >
                <TableHeaderColumn isKey hidden dataField="Id" />
                {isMobile && (< TableHeaderColumn dataField="FacilityName" width="100%" dataFormat={renderFacilityNameAndAddressMobile.bind(this)}>{props.getTranslateValue(props.translate.current, "views.iac0101.facilitynameaddressmobile")}</TableHeaderColumn>)}
                {!isMobile && (<TableHeaderColumn dataField="FacilityName" width="30%" tdStyle={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}>{props.getTranslateValue(props.translate.current, "views.iac0101.facilityname")}</TableHeaderColumn>)}
                {!isMobile && (<TableHeaderColumn dataField="Address" width="55%" tdStyle={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}>{props.getTranslateValue(props.translate.current, "views.iac0101.address")}</TableHeaderColumn>)}
                {!isMobile && (<TableHeaderColumn dataField="__select" width="6%" dataFormat={renderSelectButton.bind(this)}>{props.getTranslateValue(props.translate.current, "views.iac0101.select")}</TableHeaderColumn>)}
            </BootstrapTable>
        </div>
    );
}

export default IAC0101_Table;


// WEBPACK FOOTER //
// ./view/IAC0100/iac0100-table.jsx